import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};
class ConsignorForm {
	consignor_name:string;
	address : string;
	branch: string;
	inv_prefix: string;
	handling: string;
	freight_by: string;
	loading: string;
	contact_no: string;
	
}

@Injectable()
export class ConsignorService {

	private url = environment.url;

	constructor(private http: HttpClient) { }


	addNewConsignor(form): Observable<string>{
		return this.http.post<string>(this.url + '/masters/consignor/submit', form, http_options);
	};
	getAllConsignor(): Observable<ConsignorForm[]>{
		return this.http.get<ConsignorForm[]>(this.url + '/masters/consignor/all');
	};
	getConsignorFormWith(name:string): Observable<ConsignorForm[]> {
		return this.http.get<ConsignorForm[]>(this.url + '/masters/consignor/get/' + name);
	};
	getConsignorFormWithBranch(branch:string): Observable<ConsignorForm[]> {
		return this.http.get<ConsignorForm[]>(this.url + '/masters/consignor/get/branch/' + branch);
	};

	// delete consignor
	
}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/_services/_masters/consignor.service.ts